<mtc-toasts-host></mtc-toasts-host>
<div class="mtc-app-frame__app-container">
  <mtc-appbar [state]="this.appbarState"
              [isLoggedIn]="(this.loggedIn$ | async) ?? false"></mtc-appbar>
  <div class="mtc-app-frame__app-content">
    <router-outlet></router-outlet>
  </div>
</div>
